/* eslint-disable */

export const COLORS = {
  //   Palette Color
  palleteLight: '#edf1f7',
  palleteLightBlue: '#dbe2ef',
  palleteBlue: '#3f72af',
  palleteDarkBlue: '#112d4e',
  grayBackground: '#f1f1f1',
  submitBlue: '#0B35B3',
  bodyGrey: '#f1f1f1',
  lightGreen: '#34A770',
  orangeButtonColor: '#E58425',

  // Colors
  white: '#fff',

  stimulus: '#F080B8',
  steps: '#F0B880',
  target: '#3f72af',
  class: '#ff7171',
  graph: 'rgb(229, 132, 37)',
  mandTitle: '#3f72af',

  text: '#74708d',
  textLighten: '#c0bdd0',
  textDarken: '#615d7c',
  textDarkenMore: '#514d6a',

  grayIcon: '#707070',
  gray: '#d2d9e5',
  grayLighten: '#eef0f4',
  grayLightenMore: '#fff',
  grayLightenMoreMore: '#f9fafc',
  grayDarken: '#b8beca',
  grayBorder: '#e4e9f0',
  grayFill: '#f9f9f9',

  black: '#0e0b20',
  blackLighten: '#000',
  blackLightenMore: '#000',

  blue: '#08f',
  blueDarken: '#0072d6',
  orange: '#f2a654',
  yellow: 'yellow',

  menuBg: '#001529',
  menuBgDarken: '#000c17',

  // Accent colors
  default: '#acb7bf',
  primary: '#0190fe',
  secondary: '#6a7a84',
  success: '#46be8a',
  info: '#0887c9',
  warning: '#f39834',
  danger: '#fb434a',

  // btn color
  btnPrimaryColor: '#0b35b3',
  btnWidth: '200px',
}

export const HEADER_COLOR = [
  '#87d068',
  '#2db7f5',
  '#87d068',
  '#2db7f5',
  '#2db7f5',
  '#87d068',
  '#2db7f5',
  '#87d068',
  '#2db7f5',
  '#87d068',
  '#2db7f5',
  '#87d068',
  '#2db7f5',
  '#87d068',
  '#2db7f5',
  '#87d068',
]

export const DRAWER = {
  learnerL1: '30%',
  learnerL2: '55%',
  widthL1: '80%',
  widthL2: '60%',
  widthL3: '50%',
  widthL4: '40%',
}

export const FONT = {
  level1: '24px',
  level2: '20px',
  level3: '18px',
  level4: '14px',
  level5: '12px',
}

export const FORM = {
  layout: {
    labelCol: {
      span: 5,
    },
    wrapperCol: {
      span: 19,
    },
  },

  layout1: {
    labelCol: {
      span: 5,
    },
    wrapperCol: {
      span: 19,
    },
  },

  layout2: {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 18,
    },
  },

  tailLayout: {
    wrapperCol: {
      offset: 5,
      span: 19,
    },
  },

  tailLayout3: {
    wrapperCol: {
      offset: 6,
      span: 18,
    },
  },

  tailLayout2: {
    wrapperCol: {
      offset: 0,
      span: 15,
    },
    vertLayout: {
      labelCol: {
        span: 2,
      },
      wrapperCol: {
        span: 19,
      },
    },
  },
}

export const SUBMITT_BUTTON = {
  minWidth: 180,
  maxWidht: 'fit-content',
  height: 40,
  background: '#0b35b3',
  borderRadius: 2,
  boxShadow: '0px 2px 4px rgba(96, 97, 112, 0.16), 0px 0px 1px rgba(40, 41, 61, 0.04)',
  fontSize: 16,
  color: 'white',
  margin: '1rem',
}

export const CANCEL_BUTTON = {
  width: 180,
  height: 40,
  boxShadow: '0px 2px 4px rgba(96, 97, 112, 0.16), 0px 0px 1px rgba(40, 41, 61, 0.04)',
  borderRadius: 2,
  fontSize: 16,
  color: 'white',
  background: '#f55e53',
  margin: '1rem',

  // fontWeight: 600,
}

export const PRIMARY_ORANGE_BUTTON = {
  backgroundColor: '#E58425',
  borderColor: 'transparent',
  color: 'white',
  padding: '0 8px',
  borderRadius: '0.2rem',
  fontSize: 14,
  fontWeight: 'bold',
}

export const GREY_ICON_BUTTON = {
  color: COLORS.grayIcon,
  padding: '0 10px',
  fontSize: 18,
  fontWeight: 600,
}

export const PLUS_BUTTON = {
  position: 'absolute',
  background: '#0B35B3',
  right: 0,
  padding: 0,
  margin: 0,
  width: 30,
  height: 30.5,
  borderRadius: 0,
  border: 0,
  top: -6,
  color: 'white',
}

export const BODY_WIDTH = '120rem'
